import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const StyledSVG = styled.svg`
  width: 100%;
  height: 100%;
`;

function Logo({ bottomFill, style, viewBoxWidth }) {
  return (
    <StyledSVG viewBox={`0 0 800 ${viewBoxWidth || 180}`} style={style || {}}>
      <g>
        <g style={{ fill: '#ffffff' }}>
          <path className="st0" d="M278.17,106.43H139.64v-34.6H243.5V37.13H0.61V2.42h277.56V106.43z" />
          <path className="st0" d="M660.54,71.68v34.59H521.82V2.42h277.56v34.47H556.6v34.79H660.54z" />
          <path className="st0" d="M382.86,2.35h103.77V106.3h-34.4V37.22h-34.79v69.12h-34.58V2.35z" />
          <path className="st0" d="M347.68,106.36h-34.39V2.51h34.39V106.36z" />
          <path className="st0" d="M71.19,105.12V73.09h32.15v32.03H71.19z" />
          <path className="st0" d="M696.67,105.18V73.14h32.08v32.03H696.67z" />
        </g>
        <g>
          <g style={{ fill: bottomFill || '#EC6E90' }}>
            <path
              className="st1"
              d="M313.29,148.02c0-1,0.19-1.93,0.56-2.79c0.38-0.86,0.9-1.62,1.57-2.29c0.67-0.67,1.44-1.19,2.32-1.57
            c0.88-0.38,1.82-0.56,2.82-0.56h13.47c1,0,1.94,0.19,2.82,0.56c0.88,0.38,1.64,0.9,2.29,1.57c0.65,0.67,1.16,1.43,1.54,2.29
            c0.37,0.86,0.56,1.78,0.56,2.79v4.76h-6.58v-3.38c0-0.58-0.21-1.11-0.63-1.57c-0.42-0.46-0.96-0.69-1.63-0.69h-10.02
            c-0.63,0-1.16,0.23-1.6,0.69c-0.44,0.46-0.66,0.98-0.66,1.57v19.67c0,0.58,0.22,1.11,0.66,1.57c0.44,0.46,0.97,0.69,1.6,0.69
            h10.02c0.67,0,1.21-0.23,1.63-0.69c0.42-0.46,0.63-0.98,0.63-1.57v-4.45h-6.64v-5.26h13.22v11.09c0,1-0.19,1.93-0.56,2.79
            c-0.38,0.86-0.89,1.62-1.54,2.29c-0.65,0.67-1.41,1.19-2.29,1.57c-0.88,0.38-1.82,0.56-2.82,0.56h-13.47
            c-1,0-1.94-0.19-2.82-0.56c-0.88-0.38-1.65-0.9-2.32-1.57c-0.67-0.67-1.19-1.43-1.57-2.29c-0.38-0.86-0.56-1.78-0.56-2.79V148.02
            z"
            />
            <path
              className="st1"
              d="M359.4,141.44h6.52l13.78,35.58h-7.14l-3.45-9.21h-12.91l-3.45,9.21h-7.14L359.4,141.44z M367.24,162.24
            l-4.57-12.28l-4.57,12.28H367.24z"
            />
            <path
              className="st1"
              d="M384.71,141.44h4.89l12.72,24.81l12.72-24.81h4.89v35.58h-6.52v-18.92l-9.58,18.92h-3.01l-9.59-18.92v18.92
            h-6.51V141.44z"
            />
            <path className="st1" d="M428.69,141.44H453v5.95h-17.48v8.77h13.28v5.58h-13.28v8.96h17.92v6.33h-24.74V141.44z" />
            <path
              className="st1"
              d="M459.39,166.12h6.51v2.94c0,0.58,0.23,1.11,0.69,1.57c0.46,0.46,1,0.69,1.63,0.69h9.4
            c0.63,0,1.17-0.23,1.63-0.69c0.46-0.46,0.69-1,0.69-1.63v-3.38c0-0.42-0.12-0.82-0.34-1.22c-0.23-0.4-0.58-0.64-1.03-0.72
            l-14.91-4.01c-1.34-0.33-2.38-1.05-3.13-2.16c-0.75-1.11-1.13-2.33-1.13-3.67v-5.83c0-1,0.19-1.93,0.56-2.79
            c0.38-0.86,0.9-1.62,1.57-2.29c0.67-0.67,1.43-1.19,2.29-1.57c0.86-0.38,1.79-0.56,2.79-0.56h12.84c1,0,1.95,0.19,2.85,0.56
            c0.9,0.38,1.67,0.9,2.32,1.57c0.65,0.67,1.16,1.43,1.53,2.29c0.38,0.86,0.56,1.78,0.56,2.79v4.32h-6.58v-2.94
            c0-0.58-0.22-1.11-0.66-1.57c-0.44-0.46-0.99-0.69-1.66-0.69h-9.33c-0.63,0-1.18,0.23-1.66,0.69c-0.48,0.46-0.72,1-0.72,1.63
            v3.38c0,0.42,0.12,0.81,0.34,1.19c0.23,0.38,0.57,0.63,1.03,0.75l14.91,4.01c1.34,0.38,2.39,1.12,3.17,2.22
            c0.77,1.11,1.16,2.33,1.16,3.67v5.76c0,1-0.19,1.93-0.56,2.79c-0.38,0.86-0.89,1.62-1.53,2.29c-0.65,0.67-1.42,1.19-2.32,1.57
            c-0.9,0.38-1.85,0.56-2.85,0.56H466.6c-1,0-1.93-0.19-2.79-0.56c-0.86-0.38-1.62-0.9-2.29-1.57s-1.19-1.43-1.57-2.29
            c-0.38-0.86-0.56-1.78-0.56-2.79V166.12z"
            />
          </g>
        </g>
      </g>
    </StyledSVG>
  );
}

Logo.defaultProps = {
  bottomFill: undefined,
  style: undefined,
  viewBoxWidth: undefined,
};

Logo.propTypes = {
  bottomFill: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object,
  viewBoxWidth: PropTypes.number,
};

export default Logo;
